import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import DetailTip from 'views/mydata/common/DetailTip';
import styles from './index.module.css'

const CareerResultNone = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<div className={styles.update}>
						2022.01.01 기준<i className="icon icon_update ml_10" />
					</div>
					<div className="flex-justify_between mt_10">
						<div className={styles["l-title"]}>
							지금까지 김모니님의 총 경력은<br /><strong>0년 0개월</strong>
						</div>
						<i className="icon icon_question" onClick={openLayer} />
					</div>

					<div className={`${styles["company-info"]} mt_40`}>
						<div className={styles["company-title"]}>
							<p>지역가입자</p>
						</div>
						<span className="mt_10">2021.01.01 ~ 현재 (1년 10개월)</span>
					</div>
				</div>
			</div>
			<div className="padding">
				<h3>소득정보</h3>
				<div className="center-cont no-data-box mt_30 py_40">
					<i className="icon icon_no_data" />
					<p className="mt_20">소득 정보가 없어요.</p>
				</div>
			</div>

			<DetailTip show={showLayer} closeLayer={closeLayer} title="총 경력이 다르게 나오나요?">
				<p>
					건강보험 자격득실 확인서의 가입자 구분이 ‘직장가입자’가
					아닐 경우, 총 경력에 포함되지 않아요.
				</p>
			</DetailTip>
		</div>
	)
}

export default CareerResultNone